/**
 * Mobile-safe scroll + focus to first invalid form field.
 *
 * Pattern:
 *   - setTimeout(300ms): wait for mobile keyboard close animation (~250ms)
 *   - requestAnimationFrame: stable layout frame
 *   - smooth scroll with -100px header offset
 *   - setTimeout(350ms): focus after smooth scroll completes
 *
 * Accepts the InfluencerForm / BrandContact errors[] shape:
 *   [{ field: 'fieldName', message: '...' }, ...]
 * The first item's `field` is treated as the scroll target.
 *
 * Element lookup:
 *   document.getElementById(field) — form inputs and section containers
 *   carry an `id` matching the validation field name (Sprint UX commit
 *   4ebe479 ensured this).
 */
export const scrollToFirstError = (errors) => {
  if (!errors || errors.length === 0) return;
  const firstField = errors[0].field;
  setTimeout(() => {
    requestAnimationFrame(() => {
      const el = document.getElementById(firstField);
      if (!el) return;
      const yOffset = -100;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (typeof el.focus === 'function') {
        setTimeout(() => {
          try {
            el.focus({ preventScroll: true });
          } catch (_) {
            // some elements don't support focus; ignore
          }
        }, 350);
      }
    });
  }, 300);
};
